import Vue from 'vue';
import Vuex from 'vuex';
import { queryCurrent, logout } from '@/api/user/user';
import { getCategory } from '@/api/task/common';
import { initCategory } from '@/global/constants';
import {recentList, getExpNoPage, sso} from '@/api/user/user';
import {detail, teamForum} from '@/api/team/team'
import Cookies from 'js-cookie'


Vue.use(Vuex);

const state = {
  // 已登录用户数据
  userInfo: {},
  // 已登录用户团队数据
  team: {},
  // 点击登录按钮时 当前页面路径
  searchPath: '',
  // 当前查看的任务详情
  task: {},
  // 任务分类
  taskCategory: { ...initCategory },
  // 未读消息
  unReadMsg: {},
  // 我的技能
  myExp:[]
};
export default new Vuex.Store({
  state,
  mutations: {
    setUser(State, info) {
      State.userInfo = info;
    },
    setTeam(State, data) {
      State.team = Object.assign(State.team,data);
    },
    setTeamForum(State, data) {
      State.team = Object.assign(State.team,data);
    },
    clearUser(State) {
      State.userInfo = {};
    },
    clearTeam(State) {
      State.team = {};
    },
    // 登录前页面 登录后会跳转这个页面
    setSearchPath(State, data) {
      State.searchPath = data;
    },
    // 当前查看的任务详情数据
    setTask(State, data) {
      State.task = data;
    },
    // 任务分类
    setTaskCategory(State, data) {
      State.taskCategory = data;
    },
    // 提示信息
    setMsg(State, data) {
      State.unReadMsg = data;
    },
    // 我的技能
    setMyExp(State, data) {
      State.myExp = data;
    },
    // 打卡状态
    setClockType(State, data) {
      (State.userInfo as any).clock_type = data;
    }
  },
  actions: {
    async initUserInfo(context) {
      try {
        // 如果有SSID,则先判断
        let ssid = localStorage.getItem('ssid');
        if(ssid) {
          const session:any = await sso(ssid);
          if(session.code != '200') {
            ssid = '';
            localStorage.removeItem('ssid');
          }
        }

        if(!ssid) {
          let params = window.location.search;
          let token = params.replace(/^.+token=([^&=]+).*$/, '$1');
          if(token != params) {
            const session:any = await sso(token);
            if(session.code == '200') {
              localStorage.removeItem('ssid');
              localStorage.setItem("ssid", session.object.token);
              ssid = session.object.token;
              if(ssid != Cookies.get('token')) {
                Cookies.set('token', ssid, { expires: 1, path: '/',domain: process.env.VUE_APP_DOMAIN });
              }
            }
          }
        }

        // if(!ssid) {
        //   await logout();
        // }

        const res:any = await queryCurrent(ssid);
        if (typeof res !== 'string') {
          context.commit('setUser', res);
          //每次登录重新获取最近五条消息
          try {
            const resp = await recentList({ rows: 5 });
            context.commit('setMsg', resp);
          } catch (err) {
            console.log(err);
          }
          //每次登录重新获取我的技能
          try {
            const rese:any = await getExpNoPage({ uid: res.id });
            context.commit('setMyExp', rese);
          } catch (err) {
            console.log(err);
          }

          if (res.id) {
            try {
              const rest = await detail();
              context.commit('setTeam', rest);
            } catch (err) {
              console.log(err);
            }
            try {
              const rest2 = await teamForum();
              context.commit('setTeamForum', rest2);
            } catch (err) {
              console.log(err);
            }
          }

        }
      } catch (err) {
        console.log(err);
      }
    },
    async logoutUser(context) {
      try {
        const res = await logout();
        context.commit('clearUser');
        context.commit('clearTeam');
      } catch (err) {
        console.log(err);
      }
    },
    async getTaskCategory(context) {
      try {
        const res = await getCategory();
        context.commit('setTaskCategory', res);
      } catch (err) {
        console.log(err);
      }
    },
    async getRecentList(context) {
      if ((state.userInfo as any).id) {
        try {
          const res = await recentList({ rows: 5 });
          context.commit('setMsg', res);
        } catch (err) {
          console.log(err);
        }
      }
    },
    async getTeam(context) {
      if ((state.userInfo as any).id) {
        try {
          const res = await detail();
          context.commit('setTeam', res);
        } catch (err) {
          console.log(err);
        }
        try {
          const res2 = await teamForum();
          context.commit('setTeamForum', res2);
        } catch (err) {
          console.log(err);
        }
      }
    }
  },
});
